import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
import { Overlay } from '../../styled';
export const StyledOverlay = styled(Overlay) `
  border-radius: ${themeGet('borderRadius.circle')};
`;
